import React from 'react';
import InputEditor from './InputEditor';

export default function (value, editProperty, property, _onValue, o) {
    _onValue = _onValue || {};
    const context = this;
    const validator = o.validator;
    const idx = `${'Header' + '-'}${property}`;
    const editedCell = context.state.editedCell;
    const editedDistance = context.state.editedDistance;

    const subElement = (key, validatedValue) => {
        if (idx === editedCell && key === editedDistance) {
            return {
                value: <InputEditor
                    initialValue={value[key]}
                    onValue={(v) => {
                        const state = {};
                        state.editedCell = null;
                        state.editedDistance = null;
                        context.setState(state);
                        _onValue(v, key);
                    }}
                    type="number"
                    bsStyle=""
                />,
            };
        }
        return {
            value: validatedValue,
            props: {
                onClick: function onClick() {
                    const state = {};
                    state.editedCell = idx;
                    state.editedDistance = key;
                    context.setState(state);
                },
            },
        };
    };

    let validatedMinDistance = value.minDistance;
    let validatedMaxDistance = value.maxDistance;
    if (validator) {
        validatedMaxDistance = validator(validatedMaxDistance);
        validatedMinDistance = validator(validatedMinDistance);
    }
    const leftElement = subElement('minDistance', validatedMinDistance);
    const rightElement = subElement('maxDistance', validatedMaxDistance);

    return {
        value: (
            <div className="container-fluid">
                <div {...leftElement.props}>
                    {leftElement.value}
                </div>
                <div {...rightElement.props}>
                    {rightElement.value}
                </div>
            </div>
        ),
    };
}
